import React from 'react';
import {motion} from 'framer-motion';

export default function SectionHeader({title, label="Kompetenzbereich"}) {
  return (
    <div className="relative mb-20 text-left">
      <motion.div 
        initial={{opacity: 0, scale: 0.8}} 
        whileInView={{opacity: 1, scale: 1}} 
        viewport={{once: true}}
        className="inline-flex items-center gap-3 px-3 py-1 rounded-full bg-accent/5 border border-accent/10 mb-6"
      >
        <div className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" />
        <span className="text-[10px] font-black text-accent uppercase tracking-[0.3em]">
          {label}
        </span>
      </motion.div>
      
      <motion.h2 
        initial={{opacity: 0, y: 20}} 
        whileInView={{opacity: 1, y: 0}} 
        viewport={{once: true}}
        className="text-4xl md:text-6xl font-black text-slate-900 tracking-tight"
      >
        {title}<span className="text-accent">.</span>
      </motion.h2>
      
      <div className="absolute -left-12 top-1/2 -translate-y-1/2 hidden lg:block">
        <div className="w-8 h-[2px] bg-accent/20" />
      </div>
    </div>
  );
}